import {
  MAX_LENGTH_PLATE_NUMBER,
  MIN_BELGIAN_LENGTH_PLATE_NUMBER,
  MAX_BELGIAN_LENGTH_PLATE_NUMBER
} from 'utils/plateNumber';

const validateParking = (parking, isBelgian = false) =>
  parking.reduce(
    (acc, {checked, externalParkingChecked, plateNumber}) =>
      acc &&
      (checked || externalParkingChecked
        ? isBelgian
          ? plateNumber?.length >= MIN_BELGIAN_LENGTH_PLATE_NUMBER &&
            plateNumber?.length <= MAX_BELGIAN_LENGTH_PLATE_NUMBER
          : plateNumber?.length === MAX_LENGTH_PLATE_NUMBER
        : true),
    true
  );

export {validateParking};
